var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Country_Icon",
    "data-name": "Country Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.89,
    height: 21.89,
    viewBox: "0 0 21.89 21.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M3.283,3.283A9.936,9.936,0,0,1,10.945,0a9.936,9.936,0,0,1,7.662,3.283,9.936,9.936,0,0,1,3.283,7.661,9.936,9.936,0,0,1-3.283,7.662,9.936,9.936,0,0,1-7.662,3.283,9.936,9.936,0,0,1-7.661-3.283A10.923,10.923,0,0,1,0,10.945,9.936,9.936,0,0,1,3.283,3.283ZM12.4,19.7a4.482,4.482,0,0,0,2.736-1.642,7.967,7.967,0,0,0,1.277-3.831,3.021,3.021,0,0,0-.912-2.189,3.211,3.211,0,0,0-2.371-1.095H11.31a5.326,5.326,0,0,1-1.642-.365A1.656,1.656,0,0,1,9.121,9.3a.948.948,0,0,1,.365-.73,1.383,1.383,0,0,1,.73-.365,1.245,1.245,0,0,1,.912.547c.365.182.547.365.73.365a1.1,1.1,0,0,0,.73-.182,1.1,1.1,0,0,0,.182-.73,2.9,2.9,0,0,0-.912-1.824,7.545,7.545,0,0,0,.912-3.466.392.392,0,0,0-.365-.365,5.639,5.639,0,0,0-1.459-.365A9.125,9.125,0,0,0,6.2,3.648,4.592,4.592,0,0,0,4.56,7.3,4.671,4.671,0,0,0,6.02,10.763a4.984,4.984,0,0,0,3.466,1.459h0v.73a2.342,2.342,0,0,0,.73,1.824,2.656,2.656,0,0,0,1.642,1.095v3.283c0,.182,0,.182.182.365S12.222,19.7,12.4,19.7Z",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/Country Icon.e5c2663973bd41cad05a82fd3f3a2260.svg";
export { ForwardRef as ReactComponent };